import { Component, Input, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { ThemeModeType, ThemeModeService } from "./lang.service";
import { TranslationService } from "src/app/i18n";

@Component({
    selector: "app-lang-switcher",
    templateUrl: "./lang-switcher.component.html",
    styleUrls: ["./lang-switcher.component.scss"],
    standalone: false
})
export class LangSwitcherComponent implements OnInit {
  @Input() toggleBtnClass: string = "";
  @Input() toggleBtnIconClass: string = "svg-icon-2";
  @Input() menuPlacement: string = "bottom-end";
  @Input() menuTrigger: string = "{default: 'click', lg: 'hover'}";
  lang: string = "";

  constructor(
    private modeService: ThemeModeService,
    private translationService: TranslationService
  ) {
    this.lang = this.translationService.getSelectedLanguage();
  }

  ngOnInit(): void {}

  switchLang(lang: string): void {
    this.translationService.setLanguage(lang);
    window.location.reload();
  }
}
